export default class ConstraintSplitPointFinder {
  findSplitPoint(seg, encroachPt) {}
}
